import { CustomerRole } from 'features/customer/store/types';
import { useAppSelector } from 'store/hooks';

export function useIsTeamOwner() {
  const teamRole = useAppSelector(state => state.customer.teamRole);
  return teamRole === CustomerRole.OWNER;
}
